export default __webpack_public_path__ + "static/media/2425 cutlery side.6e8ab3bd.png";